export default "__VITE_ASSET__BgCnwUN0__"